let repeatedActions = {};

export const ACTIONS = {
  addSingleTimeTracking: 'add_single_time_tracking',
};

export const _resetRepeatedActions = () => (repeatedActions = {});

export const recordAction = (name) => {
  const entry = repeatedActions[name] ?? { amount: 0, handlers: [] };
  entry.amount++;
  repeatedActions[name] = entry;

  entry.handlers.forEach((handler) => handler({ amount: entry.amount }));
};

export const onRepeatedAction = (name, handler) => {
  const entry = repeatedActions[name] ?? { amount: 0, handlers: [] };
  const currentAmount = entry.amount;
  const newHandler = () =>
    handler({
      amount: entry.amount,
      amountSinceRegister: entry.amount - currentAmount,
    });

  entry.handlers.push(newHandler);
  repeatedActions[name] = entry;

  return () => {
    entry.handlers.splice(entry.handlers.indexOf(newHandler), 1);
  };
};
